import CheckIcon from "@mui/icons-material/Check";
import { Fragment, useContext } from "react";
import { useTranslation } from "react-i18next";
import { GlobalDataContext } from "../../../../../contexts/GlobalData";
import { STATUSES } from "../../../../../enums/AppointmentStatus";
import { ACCEPT_PENDING } from "../../../../../enums/PermissionTitles";
import useUser from "../../../../../hooks/useUser";
import ActionRow from "../../../../admin/clinic/components/actions/ActionRow";
import useAppointmentStatusChange from "../../hooks/useAppointmentStatusChange";
import {
  canChangePendingStatus,
  canManageAppointment,
} from "../../utils/appointmentActionRules";

export function canAcceptAppointment(appointment, roles, isPermissionAllowed) {
  return (
    !roles.master &&
    canManageAppointment(appointment, roles) &&
    canChangePendingStatus(appointment, isPermissionAllowed)
  );
}

export default function AcceptAppointment({ appointment }) {
  const { t } = useTranslation();
  const { roles } = useUser();
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const { changeStatus, ConfirmationDialog } =
    useAppointmentStatusChange(appointment);

  if (!canAcceptAppointment(appointment, roles, isPermissionAllowed)) {
    return null;
  }

  const hasPermission = isPermissionAllowed(ACCEPT_PENDING);

  return (
    <Fragment>
      <ActionRow
        justButton
        icon={<CheckIcon />}
        label={t("AcceptAppointmnet")}
        description={
          hasPermission
            ? t("AcceptAppointmentDesc")
            : t("NoPermissionForThisAction")
        }
        disabled={!hasPermission}
        onClick={() => changeStatus(STATUSES.ACTIVE)}
        testId={"appointment.details.accept-button"}
      />
      <ConfirmationDialog />
    </Fragment>
  );
}
